module.exports = "/img/_/_/_/assets/images/creeper/battle/common//23.jpg?e09272a24880fb7b20fad9aea6695ea1";